import React from 'react';
import { Tooltip, CircularProgress, Box } from '@mui/material';
import { 
  CheckCircle,
  Cancel,
} from '@mui/icons-material';
import { useConnectionStatus } from '../hooks/useConnectionStatus';
import { Agent } from '../types/agent';

interface WhatsAppStatusIconProps {
  agentId: string;
  agent?: Agent | null;
  size?: 'small' | 'medium' | 'large';
  connection?: ReturnType<typeof useConnectionStatus>;
}

const WhatsAppStatusIcon: React.FC<WhatsAppStatusIconProps> = ({ 
  agentId, 
  agent,
  size = 'medium',
  connection
}) => {
  const localConnection = useConnectionStatus({ agentId, agent });
  const { status, whatsappStatus } = connection ?? localConnection;

  const getIconSize = () => {
    switch (size) {
      case 'small':
        return 20;
      case 'large':
        return 32;
      default:
        return 24;
    }
  };

  const getIcon = () => {
    const loading = status.zapi.isCheckingStatus || status.whatsappNative.isCheckingStatus || whatsappStatus.isLoading;
    if (loading) {
      return <CircularProgress size={getIconSize() - 4} />;
    }

    const iconSize = getIconSize();
    const isConnected = status.zapi.isConnected || status.whatsappNative.isConnected;
    
    return isConnected
      ? <CheckCircle sx={{ fontSize: iconSize, color: 'success.main' }} />
      : <Cancel sx={{ fontSize: iconSize, color: 'error.main' }} />;
  };

  const getTooltipText = () => {
    const loading = status.zapi.isCheckingStatus || status.whatsappNative.isCheckingStatus || whatsappStatus.isLoading;
    if (loading) return 'Verificando status...';

    if (status.zapi.isConnected) {
      return status.zapi.phoneNumber
        ? `Conectado via Z-API - ${status.zapi.phoneNumber}`
        : 'Conectado via Z-API';
    }
    if (status.whatsappNative.isConnected) {
      return status.whatsappNative.phoneNumber
        ? `WhatsApp conectado - ${status.whatsappNative.phoneNumber}`
        : 'WhatsApp conectado';
    }
    return 'WhatsApp desconectado';
  };

  return (
    <Tooltip title={getTooltipText()} arrow>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {getIcon()}
      </Box>
    </Tooltip>
  );
};

export default WhatsAppStatusIcon;